/**
 * Development logging utility
 * Logs are only output when NODE_ENV is 'development'
 */

const isDev = process.env.NODE_ENV === "development";

export const devLog = (...args: unknown[]): void => {
  if (isDev) {
    console.log(...args);
  }
};

export const devWarn = (...args: unknown[]): void => {
  if (isDev) {
    console.warn(...args);
  }
};

export const devError = (...args: unknown[]): void => {
  if (isDev) {
    console.error(...args);
  }
};

/**
 * Grouped logging for related operations
 */
export const devGroup = (label: string, fn: () => void): void => {
  if (isDev) {
    console.group(label);
    fn();
    console.groupEnd();
  }
};
